import React from 'react'
import { Color } from '../../../../../utils/constants'
import { ReactComponent as Download } from '../../../../../assets/icons/download.svg'
import Button from '../../../../../components/Button/Button'

interface DownloadLinkProps {
  open?: () => void
}

const DownloadLink = ({ open }: DownloadLinkProps) => {
    return (
        <>
            <Button
                isInverted
                innerClasses='p-2 md:p-4 md:group-hover:p-4 group-hover:m-0'
                onMouseUp={(e) => e.stopPropagation()}
                buttonColor={Color.WHITE}
                onClick={(e) => {
                    if (open) {
                        e.preventDefault()
                        e.stopPropagation()
                        open()
                    }
                }}
            >
                <Download />
            </Button>
        </>
    )
}

export default DownloadLink
